import * as Scrivito from "scrivito";
import React from "react";

import { Progress } from "reactstrap";

import { useTranslate } from "hooks";

export type ProgressBarProps = {
  handleTerminateRequest: (e: React.MouseEvent) => void;
};

export const ActiveProgressBar = Scrivito.connect(
  ({ handleTerminateRequest }: ProgressBarProps) => {
    const translate = useTranslate();
    return (
      <>
        <div className="w-100 p-2_5 pb-2 d-flex align-items-center justify-content-between">
          <div>{translate("GENERATION_IN_PROGRESS")}</div>
          <button className="btn-close" onClick={handleTerminateRequest} />
        </div>
        <Progress
          value={100}
          animated={true}
          className="bg-gray-300 rounded-3 mt-1 overflow-hidden"
          color="info"
          style={{ height: "0.375rem" }}
        />
      </>
    );
  },
);
